import { instance as axios } from "./baseUrl";

export const validateTenantNameApi = (tenantName) => axios.get(`/exist-tenant/${tenantName}`);

export const listCountriesApi = (lang) => axios.get(`country/all?locale=${lang}`);

export const listLanguagesApi = () => axios.get('languague/all');

export const listTimezoneByCountryApi = (countryCode, lang) => axios.get(`timezone/${countryCode}`);

export const registerTenantDataApi = (data) => axios.post("register/saveTenant", { ...data });

export const listIndustriesByLangApi = (lang) => axios.get(`v2/tenant-industry/lang?locale=${lang}`);

export const listProfilesByLangApi = (lang) => axios.get(`v2/tenant-profile/lang?locale=${lang}`);

export const listJobRolesByLangApi = (lang) => axios.get(`/v2/tenant-charge/lang?locale=${lang}`);